import React from 'react';
import { NotificationIcon } from '@domain-group/fe-co-icon';
import { SignInType } from '@domain-group/fe-allhomes-library';
import { withAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import { withMedia } from 'react-media-query-hoc';
import * as styles from './old-property-alert-button.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var BaseOldPropertyAlertButton = _ref => {
  var _ref$buttonLabel = _ref.buttonLabel,
    buttonLabel = _ref$buttonLabel === void 0 ? 'Property alert' : _ref$buttonLabel,
    _ref$targetUrl = _ref.targetUrl,
    targetUrl = _ref$targetUrl === void 0 ? '/property-alerts' : _ref$targetUrl,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? false : _ref$responsive,
    _ref$noBorder = _ref.noBorder,
    noBorder = _ref$noBorder === void 0 ? false : _ref$noBorder,
    _ref$onPropertyAlertC = _ref.onPropertyAlertClick,
    onPropertyAlertClick = _ref$onPropertyAlertC === void 0 ? () => {} : _ref$onPropertyAlertC,
    _ref$isSignedIn = _ref.isSignedIn,
    isSignedIn = _ref$isSignedIn === void 0 ? false : _ref$isSignedIn,
    _ref$media = _ref.media,
    media = _ref$media === void 0 ? {
      mobile: true
    } : _ref$media,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? '' : _ref$type,
    _ref$openSignIn = _ref.openSignIn,
    openSignIn = _ref$openSignIn === void 0 ? () => Promise.resolve(false) : _ref$openSignIn;
  var mobile = media.mobile;
  var redirect = () => {
    if (typeof window !== 'undefined') {
      window.location.href = targetUrl;
    }
  };
  var handleOpenSignIn = event => {
    event.preventDefault();
    event.stopPropagation();
    onPropertyAlertClick();
    if (isSignedIn) {
      redirect();
    } else {
      openSignIn(SignInType.PROPERTY_ALERT).then(success => {
        if (success) {
          redirect();
        }
      });
    }
  };
  if (type === 'link') {
    return ___EmotionJSX("span", null, ___EmotionJSX("a", {
      href: mobile ? '#' : targetUrl,
      css: styles.link,
      onClick: mobile ? handleOpenSignIn : onPropertyAlertClick,
      rel: "nofollow"
    }, buttonLabel));
  }
  return ___EmotionJSX("div", null, ___EmotionJSX("a", {
    css: styles.propertyAlertButton({
      hasBorder: !noBorder
    }),
    href: mobile ? '#' : targetUrl,
    onClick: mobile ? handleOpenSignIn : onPropertyAlertClick,
    rel: "nofollow"
  }, ___EmotionJSX(NotificationIcon, {
    size: "regular"
  }), ___EmotionJSX("span", {
    css: styles.text({
      isResponsive: responsive
    })
  }, buttonLabel)));
};
export var OldPropertyAlertButton = withAllhomesContext('isSignedIn', 'openSignIn')(withMedia(BaseOldPropertyAlertButton));